// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__348eO","disabled":"FileBtn_disabled__ljYuT","warn":"FileBtn_warn__VzkBU","fade":"FileBtn_fade__23Kih"};